<div
  class="thin-scrollbar h-full w-full overflow-auto pb-6 [scrollbar-gutter:stable]"
>
  <table class="border-separate border-spacing-0">
    <thead
      cdkDropList
      cdkDropListOrientation="horizontal"
      [cdkDropListDisabled]="canAccessModel === false"
      (cdkDropListDropped)="drop($event)"
    >
      <tr>
        <th
          class="group sticky top-0 z-10 max-w-[350px] p-0 align-top"
          [ngClass]="{
            'min-w-[200px]': isTableHeaderWide === false,
            'min-w-[240px]': isTableHeaderWide === true
          }"
          *ngFor="let column of mconfigFields; let columnIndex = index"
        >
          <ng-container
            *ngTemplateOutlet="
              tHeader;
              context: { column: column, columnIndex: columnIndex }
            "
          ></ng-container>
        </th>

        <!-- <div
        style="display: contents"
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
      >
        <th
          class="border-m0 group max-w-[350px] border-4 p-0 align-top"
          [ngClass]="{
            'min-w-[200px]': isTableHeaderWide === false,
            'min-w-[240px]': isTableHeaderWide === true
          }"
          *ngFor="let column of mconfigDimensions; let columnIndex = index"
        >
          <ng-container
            *ngTemplateOutlet="
              tHeader;
              context: { column: column, columnIndex: columnIndex }
            "
          ></ng-container>
        </th>
      </div> -->

        <!-- <div
        style="display: inline"
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
      >
        <th
          class="border-m0 group max-w-[350px] border-4 p-0 align-top"
          [ngClass]="{
            'min-w-[200px]': isTableHeaderWide === false,
            'min-w-[240px]': isTableHeaderWide === true
          }"
          *ngFor="let column of mconfigNotDimensions; let columnIndex = index"
        >
          <ng-container
            *ngTemplateOutlet="
              tHeader;
              context: { column: column, columnIndex: columnIndex }
            "
          ></ng-container>
        </th>
      </div> -->
      </tr>
      <ng-template #tHeader let-column="column" let-columnIndex="columnIndex">
        <div
          *ngIf="isEdit === true"
          class="bg-m0 flex h-12 items-start justify-start space-x-3 pr-4 pt-2"
          tp="Read-only chart"
          [tpIsEnabled]="canAccessModel === false"
        >
          <div class="flex items-center justify-start">
            <div
              class="text-m500 flex h-8 w-4 select-none items-center justify-center"
              [ngClass]="{
                invisible: isDrag === true
              }"
            >
              <div *ngIf="column.sortingNumber > -1">{{
                column.sortingNumber + 1
              }}</div>
            </div>

            <button
              *ngIf="column.sorting?.desc === false"
              class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
              [ngClass]="{
                invisible: isDrag === true,
                'hover:bg-m200 text-m500': canAccessModel !== false,
                'text-s400 cursor-default': canAccessModel === false
              }"
              [disabled]="canAccessModel === false"
              (click)="sort(column.id, false)"
            >
              <m-asc-icon></m-asc-icon>
            </button>

            <button
              *ngIf="column.sorting?.desc === true"
              class="flex h-8 w-8 items-center justify-center rounded focus:outline-none"
              (click)="sort(column.id, true)"
              [ngClass]="{
                invisible: isDrag === true,
                'hover:bg-m200 text-m500': canAccessModel !== false,
                'text-s400 cursor-default': canAccessModel === false
              }"
              [disabled]="canAccessModel === false"
            >
              <m-desc-icon></m-desc-icon>
            </button>

            <button
              *ngIf="!column.sorting"
              class="invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none"
              [ngClass]="{
                'group-hover:visible': isDrag === false,
                'hover:bg-m200 text-s500': canAccessModel !== false,
                'text-s400 cursor-default': canAccessModel === false
              }"
              [disabled]="canAccessModel === false"
              (click)="sort(column.id, true)"
            >
              <m-desc-icon></m-desc-icon>
            </button>
          </div>

          <!-- <button
                class="invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                [ngClass]="{
                'group-hover:visible': isDrag === false,
                  'text-s300 cursor-default':
                    columnIndex === 0 ||
                    ([fieldClassMeasure, fieldClassCalculation].indexOf(
                      column.fieldClass
                    ) > -1 &&
                      [fieldClassMeasure, fieldClassCalculation].indexOf(
                        mconfigFields[columnIndex - 1].fieldClass
                      ) < 0),
                  'hover:bg-m200 text-s500':
                    columnIndex !== 0 &&
                    ([fieldClassMeasure, fieldClassCalculation].indexOf(
                      column.fieldClass
                    ) < 0 ||
                      [fieldClassMeasure, fieldClassCalculation].indexOf(
                        mconfigFields[columnIndex - 1].fieldClass
                      ) > -1)
                }"
                [disabled]="
                  columnIndex === 0 ||
                  ([fieldClassMeasure, fieldClassCalculation].indexOf(
                    column.fieldClass
                  ) > -1 &&
                    [fieldClassMeasure, fieldClassCalculation].indexOf(
                      mconfigFields[columnIndex - 1].fieldClass
                    ) < 0)
                "
                (click)="moveLeft(column.id)"
              >
                <m-arrow-left-icon></m-arrow-left-icon>
              </button> -->

          <!-- <button
                class="invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none"
                [ngClass]="{
                'group-hover:visible': isDrag === false,
                  'text-s300 cursor-default':
                    columnIndex + 1 === mconfigFields.length ||
                    (column.fieldClass === fieldClassDimension &&
                      mconfigFields[columnIndex + 1].fieldClass !==
                        fieldClassDimension),
                  'hover:bg-m200 text-s500':
                    columnIndex + 1 !== mconfigFields.length &&
                    (column.fieldClass !== fieldClassDimension ||
                      mconfigFields[columnIndex + 1].fieldClass ===
                        fieldClassDimension)
                }"
                (click)="moveRight(column.id)"
                [disabled]="
                  columnIndex + 1 === mconfigFields.length ||
                  (column.fieldClass === fieldClassDimension &&
                    mconfigFields[columnIndex + 1].fieldClass !==
                      fieldClassDimension)
                "
              >
                <m-arrow-right-icon></m-arrow-right-icon>
              </button> -->

          <!-- <span class="drag-handle" cdkDragHandle>☰</span> -->

          <div
            tp="A required field cannot be replaced"
            [tpIsEnabled]="canAccessModel !== false && column.required === true"
          >
            <button
              class="invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none"
              [ngClass]="{
                'group-hover:visible': isDrag === false,
                'text-s300 cursor-default':
                  canAccessModel === false || column.required === true,
                'hover:bg-m200 text-s500':
                  canAccessModel !== false && column.required === false
              }"
              [disabled]="canAccessModel === false || column.required === true"
              (click)="replaceColumn(column)"
            >
              <m-edit-icon></m-edit-icon>
            </button>
          </div>

          <div
            tp="A required field cannot be deselected"
            [tpIsEnabled]="canAccessModel !== false && column.required === true"
          >
            <button
              class="invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none"
              [ngClass]="{
                'group-hover:visible': isDrag === false,
                'text-s300 cursor-default':
                  canAccessModel === false || column.required === true,
                'hover:bg-m200 text-s500':
                  canAccessModel !== false && column.required === false
              }"
              [disabled]="canAccessModel === false || column.required === true"
              (click)="remove(column.id)"
            >
              <m-trash-icon></m-trash-icon>
            </button>
          </div>
        </div>

        <div
          cdkDrag
          cdkDragHandle
          [cdkDragDisabled]="isEdit === false || canAccessModel === false"
          class="draggable-element flex flex-col items-start justify-center overflow-hidden text-clip border-b border-r border-t border-gray-300 px-5 py-2"
          [ngClass]="{
            'drag-handle': isEdit === true && canAccessModel !== false,
            'cursor-default': canAccessModel === false,
            'border-l': columnIndex === 0,
            'bg-m150': column.fieldClass === fieldClassDimension,
            'bg-g2':
              column.fieldClass === fieldClassMeasure ||
              column.fieldClass === fieldClassCalculation
          }"
          (cdkDragStarted)="onDragStart()"
          (cdkDragEnded)="onDragEnd()"
        >
          <div *cdkDragPlaceholder></div>

          <div class="flex select-none flex-col items-start justify-center">
            <div class="truncate text-sm font-normal">{{
              column.topLabel | capitalize
            }}</div>

            <div class="flex flex-row text-left font-semibold">
              <div *ngIf="column.groupLabel"
                >{{ column.groupLabel | capitalize }} -
                {{ column.label | capitalize }}</div
              >

              <div *ngIf="!column.groupLabel">{{
                column.label | capitalize
              }}</div>
            </div>
          </div>
        </div>
      </ng-template>
    </thead>

    <tbody>
      <tr data-cy="mainTableRow" *ngFor="let row of qData; let i = index">
        <td
          data-cy="mainTableCell"
          *ngFor="let column of mconfigFields"
          class="font-ms text-s2 max-w-[350px] truncate border-b border-r border-[#e5e7eb] px-5 text-base first:border-l"
          [ngClass]="{
            'min-w-[200px]': isTableHeaderWide === false,
            'min-w-[240px]': isTableHeaderWide === true,
            'text-right': column.result === fieldResultNumber
          }"
        >
          {{
            isFormat === true ? row[column.id]?.valueFmt : row[column.id]?.value
          }}
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="chart$ | async"></div>
